<template>
  <div id="admin">
    <menu-admin />
    <div class="jumbotron jumbotron-fluid">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 class="title text-center">
              <i class="fa fa-publication"></i>
              <span v-show="expedition.id">Expedição #{{expedition.id}}</span>
              <span v-show="!expedition.id">Nova Expedição</span>
            </h1>
          </div>
        </div>
      </div>
    </div>
    <section class="int-form">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <form>
              <div class="card-details">
                <h3 class="title">Detalhes da Expedição</h3>
                <div class="row">
                  <div class="form-group col-sm-8">
                    <label for="expedition">Cliente</label>
                    <div v-if="expedition.id">
                      <span
                        v-if="expedition.client.person_or_company"
                      >{{ expedition.client.company_name }}</span>
                      <span v-else>{{ expedition.client.name }}</span>
                    </div>
                    <div v-else>
                      <v-select
                        id="expedition"
                        v-model="profile_selected"
                        :options="profile_options"
                        @search="profile_search"
                      >
                        <div slot="no-options">Nenhum cliente encontrado</div>
                      </v-select>
                    </div>
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-4">
                    <label for="order">Pedido(s)</label>
                    <span v-if="!expedition.id" style="float:right;">
                      <input
                        v-model="expedition.direct_shipping"
                        id="checkBoxRemessa"
                        type="checkbox"
                      />
                      <label for="checkBoxRemessa">remessa</label>
                      <span class="errorForm"></span>
                    </span>
                    <div v-if="expedition.id">
                      <span v-if="expedition.direct_shipping">Remessa (sem pedido)</span>
                      <span v-for="order in expedition.order" v-bind:key="order.id">#{{order.id}}</span>
                    </div>
                    <div id="order" v-else>
                      <v-select
                        v-if="!expedition.id && !expedition.direct_shipping"
                        v-model="orders_selected"
                        :options="orders_options"
                        multiple
                      >
                        <div slot="no-options">Nenhum pedido encontrado</div>
                      </v-select>
                    </div>
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-4">
                    <label for="name">Tipo de Envio</label>
                    <select
                      id="shipping_type"
                      class="form-control"
                      v-model="expedition.shipping_type"
                    >
                      <option selected value="SEDEX">Sedex</option>
                      <option value="PAC">PAC</option>
                      <option value="ACOBRAR">Sedex a cobrar</option>
                      <option value="JADLOG">JadLog</option>
                      <option value="AzulCargo">Azul Cargo</option>
                      <option value="REGISTRADA">Carta Registrada</option>
                      <option value="SIMPLES">Carta simples</option>
                    </select>
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-4">
                    <label for="name">Responsável</label>
                    <div v-if="expedition.id">{{ expedition.owner.name }}</div>
                    <div v-else>
                      <select id="staffs_options" class="form-control" v-model="expedition.owner">
                        <option
                          v-for="option in staffs_options"
                          v-bind:key="option.id"
                          v-bind:value="option.id"
                        >{{ option.name }}</option>
                      </select>
                    </div>
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-4">
                    <label for="name">Status</label>
                    <div v-if="expedition.id">{{ expedition.status | nameExpeditionStatus }}</div>
                    <div v-else>
                      <select
                        v-if="!expedition.id"
                        disabled
                        id="shipping_type"
                        class="form-control"
                        v-model="expedition.status"
                      >
                        <option selected value="1">Em Andamento</option>
                        <option value="2">Entregue</option>
                        <option value="3">Devolvido</option>
                      </select>
                    </div>
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-4">
                    <label for="name">Cod. Rastreio</label>
                    <br />
                    <input id="track_code" class="form-control" v-model="expedition.track_code" />
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-4">
                    <label for="name">Valor</label>
                    <br />
                    <input
                      id="price"
                      type="text"
                      v-model.lazy="price"
                      v-money="money"
                      class="form-control"
                      placeholder
                      aria-label
                      aria-describedby="basic-addon1"
                    />
                    <span class="errorForm"></span>
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="form-group col-sm-12">
                    <label>Destinatário</label>
                    <br />
                    <ul class="list-group" v-if="profile_selected">
                      <li class="list-group-item">
                        <strong>{{ profile_selected.label }}</strong>
                        <br />
                        <span>
                          {{profile_selected.shipping_address.street}}, {{profile_selected.shipping_address.number}}
                          <br v-if="profile_selected.shipping_address.complement" />
                          {{profile_selected.shipping_address.complement}}
                          <br />
                          {{profile_selected.shipping_address.province}}
                          <br />
                          {{profile_selected.shipping_address.city}} - {{profile_selected.shipping_address.state}}
                          <br />
                          {{profile_selected.shipping_address.country}}
                          <br />
                          {{profile_selected.shipping_address.zip_code}}
                        </span>
                      </li>
                    </ul>
                    <small v-if="!profile_selected">Nenhum cliente encontrado. Selecione um cliente.</small>
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="form-group col-sm-12">
                    <label>Pedidos Selecionados</label>
                    <br />
                    <small
                      v-if="orders_selected.length == 0"
                    >Nenhuma publicação encontrada. Selecione um pedido.</small>
                    <ul class="list-group" v-for="item in orders_selected" v-bind:key="item.id">
                      <li class="list-group-item">
                        <strong># {{item.id}}</strong>
                        <br />
                        <span>
                          Nf-e: {{item.nfe}}
                          <br />
                          Envio orçado: R$ {{item.shipping_value | formatPrice}}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="form-group col-sm-12">
                    <label>Publicações Selecionadas</label>
                    <br />
                    <small
                      v-if="publications.length == 0"
                    >Nenhuma publicação encontrada. Selecione um pedido.</small>
                    <ul class="list-group" v-for="item in publications" v-bind:key="item.id">
                      <li class="list-group-item" v-if="!item.publication.is_download">
                        <strong>{{item.publication.name}}</strong>
                        <br />
                        Peso da publicação: {{item.publication.weight | formatPrice}}Kg
                        <span
                          v-if="item.publication.has_airplane_info"
                        >
                          <br />
                          Prefixo: {{item.airplane_prefix}} |
                          Serial: {{item.airplane_serial_number}} |
                          Combustível: {{item.fuel_type | nameFuelType}}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="form-group col-sm-12">
                    <label for="note">Observação</label>
                    <textarea id="note" rows="5" class="form-control" v-model="expedition.note"></textarea>
                    <span class="errorForm"></span>
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="form-group col-sm-3">
                    <label for="name">Data de Criação</label>
                    <br />
                    <!--                                        <datepicker input-class="form-control datepickerReadOnly" name="dates" v-model="creation_date" :format="customFormatter"></datepicker>-->
                    {{ expedition.creation_date | formatDate }}
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-3">
                    <label for="name">Data de Envio</label>
                    <br />
                    <datepicker
                      input-class="form-control datepickerReadOnly"
                      name="dates"
                      v-model="send_date"
                      :format="customFormatter"
                    ></datepicker>
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-3">
                    <label for="name">Data de Entrega</label>
                    <br />
                    <datepicker
                      input-class="form-control datepickerReadOnly"
                      name="dates"
                      v-model="complete_date"
                      :format="customFormatter"
                    ></datepicker>
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-3">
                    <label for="name">Data de Devolução</label>
                    <br />
                    <datepicker
                      input-class="form-control datepickerReadOnly"
                      name="dates"
                      v-model="return_date"
                      :format="customFormatter"
                    ></datepicker>
                    <span class="errorForm"></span>
                  </div>
                </div>
                <hr />
                <div class="row"></div>
              </div>
              <hr />
              <div class="card-details" style="padding-top: 0">
                <div class="row">
                  <div class="form-group col-sm-12">
                    <div
                      id="sucessUpdate"
                      class="alert alert-success text-center"
                      role="alert"
                      style="display: none;"
                    >As informações foram salvas com sucesso</div>
                    <div
                      id="errorFound"
                      class="alert alert-danger text-center"
                      role="alert"
                      style="display: none"
                    >Um erro foi encontrado. Verifique os campos do formulário</div>
                    <button
                      type="button"
                      class="btn btn-secondary"
                      onclick="window.history.back()"
                    >Voltar</button>
                    <button
                      type="button"
                      class="btn btn-primary pull-right"
                      @click="saveExpedition()"
                    >Salvar</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
    <footer-admin />
  </div>
</template>

<script>
import user from "../../api/user";
import expedition from "../../api/expedition";
import signature from "../../api/signature";
import menuAdmin from "../admin/common/menu-admin";
import footerAdmin from "../admin/common/footer-admin";
import { mapState } from "vuex";
import mixins from "../../helpers/mixins";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import { VMoney } from "v-money";

export default {
  name: "AdminExpeditionsView",
  mixins: [mixins],
  data() {
    return {
      expedition: {
        id: null,
        direct_shipping: false,
        shipping_type: "SEDEX",
        status: 1,
        owner: { name: null },
        client: { person_or_company: null, name: null },
      },
      profile_selected: "",
      profile_options: [],
      orders_selected: [],
      orders_options: [],
      price: 0,
      publications: [],
      staffs_options: [],
      // creation_date: '',
      send_date: "",
      complete_date: "",
      return_date: "",
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false /* doesn't work with directive */,
      },
    };
  },
  components: { menuAdmin, footerAdmin, Datepicker },
  directives: { money: VMoney },
  methods: {
    saveExpedition() {
      $("#sucessUpdate").hide();
      $(".errorForm").html("");

      this.expedition.order = [];
      for (let key_order in this.orders_selected) {
        this.expedition.order.push(this.orders_selected[key_order].id);
      }

      this.expedition.value = parseFloat(
        this.price.replace(/\./g, "").replace(",", ".")
      );
      // this.expedition.creation_date = moment(this.creation_date).format('YYYY-MM-DD')
      if (this.send_date)
        this.expedition.send_date = moment(this.send_date).format("YYYY-MM-DD");
      if (this.complete_date)
        this.expedition.complete_date = moment(this.complete_date).format(
          "YYYY-MM-DD"
        );
      if (this.return_date)
        this.expedition.return_date = moment(this.return_date).format(
          "YYYY-MM-DD"
        );
      this.expedition.client = this.profile_selected.id;

      if (isNaN(this.expedition.owner))
        this.expedition.owner = this.expedition.owner.id;

      if (this.expedition.shipping === false) this.expedition.shipping = 0;
      else this.expedition.shipping = 1;

      $("#errorFound").hide();
      if (this.expedition.id > 0) {
        expedition
          .update(this.expedition, this.expedition.id)
          .then((response) => {
            if (response.status === 200) {
              $("#sucessUpdate").show();
              this.getExpedition(response.data.id);
            } else {
              alert("ATENÇÃO: Não foi possivel atualizar a publicação!");
            }
          })
          .catch((errors) => {
            this.formErrors(errors);
          });
      } else {
        expedition
          .create(this.expedition)
          .then((response) => {
            if (response.status === 201) {
              $("#sucessUpdate").show();
              this.getExpedition(response.data.id);
            } else {
              alert("ATENÇÃO: Não foi possivel salvar a expedição!");
            }
          })
          .catch((errors) => {
            this.formErrors(errors);
          });
      }
    },
    profile_search(search, loading) {
      loading(true);
      expedition.get_clients(search).then((response) => {
        this.users = response.data;

        let options = [];
        this.users.forEach(function (item) {
          let name = null;
          if (item.person_or_company) {
            name = item.company_name;
          } else {
            name = item.name;
          }
          options.push({
            label: name,
            id: item.id,
            shipping_address: item.shipping_address,
          });
        });
        this.profile_options = options;

        loading(false);
      });
    },
    getExpedition(id) {
      expedition.get(id).then((response) => {
        this.expedition = response.data;
        this.price = this.expedition.value;

        // if(response.data.creation_date)
        //     this.creation_date = moment(this.expedition.creation_date).format('MM/DD/YYYY')
        if (response.data.send_date)
          this.send_date = moment(this.expedition.send_date).format(
            "MM/DD/YYYY"
          );
        if (response.data.complete_date)
          this.complete_date = moment(this.expedition.complete_date).format(
            "MM/DD/YYYY"
          );
        else this.complete_date = null;
        if (response.data.return_date)
          this.return_date = moment(this.expedition.return_date).format(
            "MM/DD/YYYY"
          );
        else this.return_date = null;

        let name = null;
        if (this.expedition.client.person_or_company) {
          name = this.expedition.client.company_name;
        } else {
          name = this.expedition.client.name;
        }
        this.profile_selected = {
          label: name,
          id: this.expedition.client.id,
          shipping_address: this.expedition.client.shipping_address,
        };

        this.orders_options = this.expedition.order;
        this.orders_selected = this.expedition.order;
      });
    },
    getSignature(id) {
      signature.get(id).then((response) => {
        this.signature = response.data;
        let name = null;
        if (this.signature.profile.person_or_company) {
          name = this.signature.profile.company_name;
        } else {
          name = this.signature.profile.name;
        }
        this.profile_selected = {
          label: name,
          id: this.signature.profile.id,
          shipping_address: this.signature.profile.shipping_address,
        };
        
        console.log(this.signature.order)
      }).catch((error) => {
        console.error(error);
      });
    },
    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },
  },
  watch: {
    profile_selected: function (item) {
      if (item != null) {
        if (typeof item.id !== "undefined" && !this.expedition.id) {
          expedition.get_orders(item.id).then((response) => {
            this.orders = response.data;
            this.orders_selected = [];

            let options = [];
            this.orders.forEach(function (item) {
              options.push({
                label: "#" + item.id,
                id: item.id,
                publications: item.publications,
                nfe: item.nfe,
                shipping_value: item.shipping_value,
              });
            });

            this.orders_options = options;
          });
        }
      } else {
        this.orders_options = [];
      }
    },
    orders_selected: async function (item) {
      this.publications = [];
      let change_price = false;
      if (this.price == "0,00") change_price = true;
      for (let key in item) {
        if (typeof item[key].id !== "undefined") {
          for (let ko in this.orders_options) {
            if (this.orders_options[ko].id == item[key].id) {
              if (change_price)
                this.price =
                  this.price + this.orders_options[ko].shipping_value;
              for (let kp in this.orders_options[ko].publications) {
                this.publications.push(
                  this.orders_options[ko].publications[kp]
                );
              }
            }
          }
        }
      }
    },
  },
  computed: {
    ...mapState(["logged"]),
  },
  mounted() {
    if (this.$route.params.id !== undefined && this.$route.params.id > 0) {
      this.getExpedition(this.$route.params.id);
    } else if (
      this.$route.params.signature !== undefined &&
      this.$route.params.signature !== ""
    ) {
      this.getSignature(this.$route.params.signature)
      user.get_staffs().then((response) => {
        this.staffs_options = response.data;
        this.expedition.owner = this.$store.state.user.id;
      });
    } else {
      user.get_staffs().then((response) => {
        this.staffs_options = response.data;
        this.expedition.owner = this.$store.state.user.id;
        // if(!this.creation_date){
        //     this.creation_date = new Date()
        // }
      });
    }
  },
};
</script>

<style scoped>
.jumbotron-fluid {
  padding-top: 100px;
  padding-bottom: 20px;
  margin-bottom: 10px;
}
</style>